import _ from "lodash";
import utils from './utils'

const getValidateResult = (chapters) => {
  let res = true;
  chapters.forEach((chapter) => {
    chapter.forEach((flag) => {
      res = res && flag;
    });
  });
  return res;
};

const getSectionKey = (chapterIndex, sectionIndex) => {
  return `/${chapterIndex}/section-0${sectionIndex}`.replace(/0(\d{2})/, "$1");
};

const setFormItemRequired = (properties, chapterIndex, sectionIndex, keys, required) => {
  let sectionKey = getSectionKey(chapterIndex, sectionIndex);
  let section = properties[sectionKey];
  keys.forEach((key) => {
    section[key].Required = required;
  });
};

const setFormItemDisabled = (properties, chapterIndex, sectionIndex, keys, disabled) => {
  let sectionKey = getSectionKey(chapterIndex, sectionIndex);
  let section = properties[sectionKey];
  keys.forEach((key) => {
    section[key].Disabled = disabled;
  });
};

const setFormItemVisible = (properties, chapterIndex, sectionIndex, keys, visible) => {
  let sectionKey = getSectionKey(chapterIndex, sectionIndex);

  properties[sectionKey].forEach((obj) => {
    if (keys.indexOf(obj.Key) >= 0) obj.Visible = visible;
  });
};

const setFormItemWithCustom = ($vm, type, obj, autocompleteObject, ...args) => {
  console.log(type, args)
  $vm.setFormItemWithCustom({ type, obj, autocompleteObject, args });
};

const houseHooks = ($vm, type, obj, ...args) => {
  $vm.houseHooks({ type, obj, args });
};

const trafficHooks = ($vm, type, obj, ...args) => {
  $vm.trafficHooks({ type, obj, args });
};

const setFormItemValue = (form, keys, value) => {
  keys.forEach((key) => {
    form[key] = value;
  });
};

const initTenderCount = (config) => {
  let count = {
    success: 0,
    total: 0,
    chapters: [],
  };
  config &&
    config.Chapters.forEach((chapter) => {
      let _chapter = {
        success: 0,
        total: 0,
        title: chapter.Title,
        sections: [],
      };
      count.chapters.push(_chapter);
      chapter.Sections.forEach((section) => {
        _chapter.sections.push({
          success: 0,
          total: 0,
          title: section.Title,
        });
      });
    });
  return count;
};

const refEvent = _.debounce((isOnlySet, $this) => {
  let { options = {} } = $this;
  let { Refs = [] } = options;
  Refs.forEach((eRef) => {
    let [type, ...args] = eRef;
    if (type === "setFormItemWithCustom") {
      utils.anoyFunction(() => {
        let [type, ...x] = args;
        setFormItemWithCustom($this, type, options, ...x);
      });
    }
    if (type === "houseHooks") {
      utils.anoyFunction(() => {
        let [type, ...x] = args;
        houseHooks($this, type, options, ...x, isOnlySet);
      });
    }
    if (type === "trafficHooks") {
      utils.anoyFunction(() => {
        let [type, ...x] = args;
        trafficHooks($this, type, options, ...x, isOnlySet);
      });
    }
  });
  $this.doValidate();
}, 1000)

export default {
  getValidateResult,
  setFormItemRequired,
  setFormItemDisabled,
  setFormItemVisible,
  setFormItemWithCustom,
  houseHooks,
  trafficHooks,
  setFormItemValue,
  initTenderCount,
  refEvent
};
